import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import { SearchQuickActions, SearchQuickSelectors } from '@core/search-data';
import type { CandidateSelectOption } from '@core/search-types';

import { CandidateSelectDropdownStrategy } from '../../types/candidate-select-dropdown-strategy';

@Injectable()
export class QuickSearchStrategyService extends CandidateSelectDropdownStrategy {
  private readonly store = inject(Store);

  public candidates: Observable<CandidateSelectOption[]> = this.store
    .select(SearchQuickSelectors.data)
    .pipe(filterBoolean, pluck('candidates', 'hits'));

  public fetch(query: string, selectedLength: number) {
    this.store.dispatch(
      SearchQuickActions.fetch({
        payload: {
          query,
          options: {
            only: 'candidates',
            limit: selectedLength + 5,
          },
        },
      }),
    );
  }
}
